import React from "react";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";

const PressCard = ({ image, logo, logoAlt, logoStyle, title, link, linkText }) => (
  <Card>
    <ImageWrapper>
      <Image
        src={image}
        alt={title}
        width={612}
        height={268}
        loading="lazy"
        decoding="async"
      />
    </ImageWrapper>
    <CardContent>
      <Logo>
        <img
          src={logo}
          alt={logoAlt || "Publication logo"}
          width={324}
          height={60}
          loading="lazy"
          decoding="async"
        />
      </Logo>
      <Title>{title}</Title>
      <ReadLink href={link} target="_blank" rel="noopener noreferrer">{linkText}</ReadLink>
    </CardContent>
  </Card>
);

export default PressCard;

const Card = styled.div`
  background: #fff;
  border: 2px solid #ececec;
  border-radius: 16px;
  overflow: hidden;
  width: auto;
  display: flex;
  flex-direction: column;
  margin: 0 ;
  padding:2rem;
  flex: 1 1 0;
  min-width: 30rem;
  width: auto;

  @media (max-width: 768px) {
    width: 100%;
    padding:2rem;
    margin: 0;
    flex: none;
    min-width: 0;
    border-radius: 1.6rem;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius:4px;
`;
const ImageWrapper = styled.div`
  height: 17.5rem;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 4rem;
`;

const Logo = styled.div`
  margin-bottom: 1rem;
  img {
    height: 2.4rem;
    width: auto;
    display: block;
  }
`;

const Title = styled.div`
  font-size: 1.6rem;
  color: #1D1D1F;
  font-weight: 400;
  margin-bottom: 18px;
  font-family: 'Lato';

  @media (max-width: 768px) {
    font-size: 1.33rem;
  }
`;

const ReadLink = styled(SafeLink)`
  color: #6725F4;
  font-family: 'Lato';
  font-size: 1.8rem;
  font-weight: 700;
  text-decoration: none;
  margin-top: auto;
  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 1.55rem;
  }
`;
